"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TAG_MANAGER_ID = exports.SECONDARY_TAG_MANAGER_ID = void 0;
var TAG_MANAGER_ID = exports.TAG_MANAGER_ID = "GTM-KBG5R38";
var SECONDARY_TAG_MANAGER_ID = exports.SECONDARY_TAG_MANAGER_ID = "GTM-WQ66RFFG";